
export default class Animation {
  constructor({
    query = '.site-animation',
    defaultDelay = 100,
    rootMargin = '0px 0px -10% 0px',
    threshold = 0,
  } = {}) {

    this.elements = document.querySelectorAll(query);
    if (!this.elements.length) return;

    this.defaultDelay = defaultDelay;
    this.rootMargin = rootMargin;
    this.threshold = threshold;

    this.init();
  }

  init() {
    this.observer = new IntersectionObserver(
      (entries) => this.handleIntersect(entries),
      {
        root: null,
        threshold: this.threshold,
        rootMargin: this.rootMargin,
      }
    );

    this.elements.forEach((el) => {
      this.observer.observe(el);
    });
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;

      const element = entry.target;
      const delay = this.getDelay(element);

      setTimeout(() => {
        element.classList.add('animated');
      }, delay);

      this.observer.unobserve(element);
    });
  }

  getDelay(element) {
    if (element.dataset.delay) {
      const parsed = Number(element.dataset.delay);
      if (!Number.isNaN(parsed) && parsed >= 0) {
        return parsed;
      }
    }

    return this.defaultDelay;
  }
};
